// const baseurl = "http://122.186.126.218:8002";
// const baseurl = "http://122.186.126.218:8023";
// const baseurl = "http://43.205.101.135:8000";
// const baseurl = "http://27.7.57.93:8001";
const baseurl = "https://api.prashanthhospitals.org";
// const baseurl = "http://122.165.75.213:8000";
// const baseurl = "http://192.168.5.234:9004";
// const baseurl = "http://192.168.1.28:9000"

export const loginapi = baseurl + "/adminlogin/";

export const adminlist = baseurl + "/adminpanel/v1/";

export const admincreate = baseurl + "/adminpanel/v1/";

export const doctorlist = baseurl + "/doctor/doctordetails/v1/";

export const doctorcreate = baseurl + "/doctor/doctordetails/v1/";

export const spacilitylist = baseurl + "/doctor/speciality/v2/";

export const spacilitycreate = baseurl + "/doctor/speciality/v2/";

export const symptomslist = baseurl + "/doctor/symptoms/v6/";

export const symptomscreate = baseurl + "/doctor/symptoms/v6/";

export const basetime = baseurl + "/doctor/basetime/v3/";

export const appoinment = baseurl + "/appointment/v1/";

export const presignedurl = baseurl + "/media/presignedurl/";

export const doctimeslot = baseurl + "/doctor/getslotsdoctor/";

export const patientlist = baseurl + "/patient/admin/v1/";

export const dashboard = baseurl + "/admindashboard/";

export const pharmacy = baseurl + "/pharmacy/v1/";

export const banner = baseurl + "/bannerdisplay/v2/";

export const Dbanner = baseurl + "/bannerdisplaydia/v3/";

export const ProductOrderGet = baseurl + "/pharmacy/v2/";

export const InvestigationGet = baseurl + "/diagnostics/investigations/v2/";

export const Packagesget = baseurl + "/diagnostics/packages/v3/";

export const trackorder = baseurl + "/pharmacy/trackorderedit/";

export const pharmacytrackorder = baseurl + "/pharmacy/obtaintrackorder/";

export const diagnosticsissue = baseurl + "/diagnostics/reportissue/v4/";

export const pharmacyissue = baseurl + "/pharmacy/v3/";

export const pharmacyissuelist = baseurl + "/issuelist/v4/";

export const bannervideo = baseurl + "/bannerdisplaydoctor/v5/";

export const pharmacybill = baseurl + "/pharmacyopbilllist/";

export const diagnosticsbill = baseurl + "/diagnosticsopbilllist/";

export const billpayments = baseurl + "/ipbillpaymentlist/";

export const notification = baseurl + "/pushnotificationsend/";

export const notificationall = baseurl + "/pushnotificationall/";

export const diagnosticsorder = baseurl + "/diagnostics/diagnosticsorder/v5/";

export const diagnostictracksorder =
  baseurl + "/diagnostics/obtaintrackorderdiagonostics/";

export const duagnosticstrackorder =
  baseurl + "/diagnostics/trackordereditdiagnostics/";

export const cashback = baseurl + "/editloyaltypointslist/";

export const appointmentdetails = baseurl + "/appointmentdetails/";

export const pharmacydetails = baseurl + "/pharmacydetails/";

export const diagnosticsdetails = baseurl + "/diagnosticsdetails/";

export const billinglist = baseurl + "/getbillingresponsedata/";

export const updatehospitalservices =
  baseurl + "/diagnostics/savediagnostic/1/";

export const updateinvestigations = baseurl + "/diagnostics/savediagnostic/2/";

export const updatepackages = baseurl + "/diagnostics/savediagnostic/3/";

export const updatedoctor = baseurl + "/specialitydoctoradd/1";

export const updatespeciality = baseurl + "/specialitydoctoradd/0";

export const updateproduct = baseurl + "/specialitydoctoradd/2";

export const specialitydelete = baseurl + "/doctor/speciality/v2/";

export const symptomsdelete = baseurl + "/doctor/symptoms/v6/";

export const appoinmentsreschedule =
  baseurl + "/appointmentcancelreschedulelist/";

export const appoinmentsrescheduleclosed =
  baseurl + "/appointmentcancelrescheduleedit/";

export const appoinmentdelete = baseurl + "/appointment/v1/";

export const appoinmentrescheduleapi = baseurl + "/appointment/v1/";

export const patienttestimonials = baseurl + "/patienttestimonials/v6/";

export const dashboardbannerapi = baseurl + "/bannertop/v1/";

export const doctorexcel = baseurl + "/excelsheetgeneration/1/";

export const specialitiesexcel = baseurl + "/excelsheetgeneration/2/";

export const symptomsexcel = baseurl + "/excelsheetgeneration/3/";

export const packagesexcel = baseurl + "/excelsheetgeneration/4/";

export const ipbillexcel = baseurl + "/excelsheetgeneration/5/";

export const oppharmacybillexcel = baseurl + "/excelsheetgeneration/6/";

export const opdiagnosticsbillexcel = baseurl + "/excelsheetgeneration/7/";

export const pharmacyexcel = baseurl + "/excelsheetgeneration/8/";

export const pharmacynew = baseurl + "/pharmacy/v5/";

export const medicinetype = baseurl + "/pharmacy/v4/";

export const pharmacybanner = baseurl + "/pharmabestoffers/v7/";

export const pharmacyrequest = baseurl + "/pharmacy/v2/";

export const pharmacyrequestput = baseurl + "/editpharmacart/";

export const generatereportpharmacy = baseurl + "/finalbillamount/";

export const sidebar_menu = baseurl + "/sidebarmenu/v8/";

export const request_presc_pdf_generate = baseurl + "/addcartdataadmin/";

export const pharmacy_status_bypass = baseurl + "/bypassstatuspharmacy/";

export const not_available = baseurl + "/doctor/doctorholiday/v5/";

export const app_settings =
  baseurl + "/appsettingsedit/3e5e5d67-a750-4f20-98f1-c636270c08e9";

export const PharmacyAppoinmentlist = baseurl + "/pharmacycancelList/";

export const PharmacyAppoinmentEdit = baseurl + "/pharmacycanceledit/";

export const DiagnosticsAppoinmentlist = baseurl + "/diagnosticscancelList/";

export const DiagnosticsAppoinmentEdit = baseurl + "/diagnosticscanceledit/";

export const OpipcancelList = baseurl + "/opipcancelList/";

export const Opipcanceledit = baseurl + "/opipcanceledit/";

export const Opipstatuschange = baseurl + "/OpIpStatusChange/";

export const financialdata = baseurl + "/finaldashboarddata/";

export const product_return = baseurl + "/pharmacy/returnrequest/";

export const currentCashbackGetApi = baseurl + "/cashbackpoints/";
export const revisedCashbackAmountGetApi = baseurl + "/editreturnmoneylist/";
